import { LoadingState } from '../../types/loading-state';
import { createFetchedData } from '../../utils/fetched-data/create-fetched-data';
export const defaultLoyaltyDomainState = {
    balanceTypesById: {},
    clubsById: {},
    clubLevelsById: {},
    customPreferencesById: {},
    educationLevelsById: {},
    emailAvailability: undefined,
    filmsById: {},
    friendConfiguration: createFetchedData(LoadingState.NotLoaded),
    genresById: {},
    interestsById: {},
    interestContactMethodsById: {},
    itemsById: {},
    masterData: createFetchedData(LoadingState.NotLoaded),
    memberHash: undefined,
    memberPhotoRequirements: createFetchedData(LoadingState.NotLoaded),
    memberRewards: createFetchedData(LoadingState.NotLoaded),
    memberWatchlistFilmsById: createFetchedData(LoadingState.NotLoaded),
    occupationsById: {},
    rewardsById: {},
    showtimesById: {},
    sitesById: {},
    subscriptionsById: {},
    ticketTypesById: {}
};
